import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import {
  SetTurboMode,
  StartPolling,
  StopPolling,
  ToggleTurboMode,
  UpdateLastPoll} from "./donation-polling.action";

/**
 * Estado do polling de doações
 */
export interface DonationPollingStateModel {
  isTurboMode: boolean;
  isPolling: boolean;
  lastUpdate: Date | null;
}

/**
 * State NGXS para gerenciar polling de doações
 * Segue Single Responsibility Principle - gerencia apenas estado de polling
 */
@State<DonationPollingStateModel>({
  name: "donationPolling",
  defaults: {
    isTurboMode: true,
    isPolling: false,
    lastUpdate: null}})
@Injectable()
export class DonationPollingState {
  @Selector()
  static isTurboMode(state: DonationPollingStateModel): boolean {
    return state.isTurboMode;
  }

  @Selector()
  static isPolling(state: DonationPollingStateModel): boolean {
    return state.isPolling;
  }

  @Selector()
  static lastUpdate(state: DonationPollingStateModel): Date | null {
    return state.lastUpdate;
  }

  @Action(ToggleTurboMode)
  toggleTurboMode(ctx: StateContext<DonationPollingStateModel>) {
    const state = ctx.getState();
    ctx.patchState({ isTurboMode: !state.isTurboMode });
  }

  @Action(SetTurboMode)
  setTurboMode(
    ctx: StateContext<DonationPollingStateModel>,
    action: SetTurboMode,
  ) {
    ctx.patchState({ isTurboMode: action.isTurbo });
  }

  @Action(UpdateLastPoll)
  updateLastPoll(ctx: StateContext<DonationPollingStateModel>) {
    ctx.patchState({ lastUpdate: new Date() });
  }

  @Action(StartPolling)
  startPolling(ctx: StateContext<DonationPollingStateModel>) {
    ctx.patchState({ isPolling: true });
  }

  @Action(StopPolling)
  stopPolling(ctx: StateContext<DonationPollingStateModel>) {
    ctx.patchState({ isPolling: false });
  }
}
